import React, { Component } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { FontFamily } from '@zocdoc/components/src/typography';
import { navy } from '@zocdoc/branding/colors';
import JanuaryWellnessRecommendation from './components/JanuaryWellnessRecommendation';
import { LOCALIZED_STRINGS } from './constants';
import Confetti from './assets/confetti-desktop.svg';

class JanuaryWellnessView extends Component {
    static propTypes = {
        recommendations: PropTypes.array.isRequired,
    };

    render() {
        return (
            <JanuaryWellnessViewWrapper
                data-test="january-wellness-view"
            >
                <JanuaryWellnessHeader
                    data-test="january-wellness-header"
                >
                    <FormattedMessage {...LOCALIZED_STRINGS.HeaderTitle} />
                </JanuaryWellnessHeader>
                <JanuaryWellnessMessage
                    data-test="january-wellness-message"
                >
                    <FormattedMessage {...LOCALIZED_STRINGS.HeaderMessage} />
                </JanuaryWellnessMessage>
                <RecommendationSection
                    data-test="january-wellness-recommendation-section"
                >
                    {this.renderRecommendations()}
                </RecommendationSection>
            </JanuaryWellnessViewWrapper>
        );
    }

    renderRecommendations() {
        const {
            recommendations,
        } = this.props;

        return recommendations.map(recommendation => {
            const {
                description,
                procedure_id: procedureId,
            } = recommendation;

            return (
                <JanuaryWellnessRecommendation
                    key={`january-wellness-rec-procedure-${procedureId}`}
                    data-test={`january-wellness-rec-procedure-${procedureId}`}
                    description={description}
                    procedureId={procedureId}
                />
            );
        });
    }
}

const JanuaryWellnessViewWrapper = styled.div`
    background: url(${Confetti}) center no-repeat;
    background-position-y: 0;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    padding: 60px 100px 50px 100px;
`;

const JanuaryWellnessHeader = styled.div`
    color: ${navy};
    font: 28px/.75 ${FontFamily.SharpSansBold};
    text-align: center;
    width: 100%;
`;

const JanuaryWellnessMessage = styled.div`
    color: ${navy};
    font: 15px/1.47 ${FontFamily.SharpSansMedium};
    padding-top: 15px;
    text-align: center;
    width: 100%;
`;

const RecommendationSection = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-top: 40px;
`;

export {
    JanuaryWellnessView as default,
    JanuaryWellnessView,
};
